<template>
  <a-modal
    title="操作"
    style="top: 20px"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item style="display: none">
        <a-input v-decorator="['roleId']" />
      </a-form-item>

      <a-form-item
        v-if="userType === '00' || userType === '66'"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="企业名称"
      >
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="['relationId', { rules: [{ required: true, message: '请输入用户名' }] }]"
          @change="changeEnterprise"
          :allowClear="true"
          :disabled="RoleType"
        >
          <a-select-option v-for="type in enterpriseMap" :key="type.enterpriseId"
            >{{ type.enterpriseName }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色名称">
        <a-input
          v-decorator="[
            'roleName',
            {
              rules: [{ required: true, message: '请输入角色名称' }],
            },
          ]"
        />
      </a-form-item>
      <!--      <a-form-item-->
      <!--        :labelCol="labelCol"-->
      <!--        :wrapperCol="wrapperCol"-->
      <!--        label="权限字符"-->
      <!--      >-->
      <!--        <a-input-->
      <!--          v-decorator="['roleKey',{rules: [{ required: true, message: '请输入权限字符' }]}]"-->
      <!--          />-->
      <!--      </a-form-item>-->
      <!--      <a-form-item-->
      <!--        :labelCol="labelCol"-->
      <!--        :wrapperCol="wrapperCol"-->
      <!--        label="显示顺序"-->
      <!--      >-->
      <!--        <a-input-->
      <!--          v-decorator="['roleSort',{rules: [{ required: true, message: '请输入顺序' }]}]"-->
      <!--          />-->
      <!--      </a-form-item>-->

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
        <a-select v-decorator="['status', { initialValue: '0', rules: [{ required: true, message: '请选择状态' }] }]">
          <a-select-option :value="'0'">正常</a-select-option>
          <a-select-option :value="'1'">禁用</a-select-option>
        </a-select>
      </a-form-item>

      <a-divider />
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="拥有权限">
        <a-tree checkable v-model="checkedKeys" @check="onCheck" :treeData="permissions"> </a-tree>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { getEntPermissions, getRolePermIds, saveRole } from '@/api/system'
import store from '@/store'
import pick from 'lodash.pick'
import { getselectCombox } from '../../../api/order/NewlyaddedOrderList'

export default {
  name: 'EntRoleModal',
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      visible: false,
      confirmLoading: false,
      mdl: {},

      form: this.$form.createForm(this),
      permissions: [],
      treeCheck: false,
      pidSet: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      enterpriseMap: [],
      userType: '',
      RoleType: '',
    }
  },
  async created() {
    // 企业名称
    await getselectCombox().then((res) => {
      if (res.code === 0) {
        this.enterpriseMap = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    this.userType = store.getters.userType
    this.id = store.getters.enterpriseId
    console.log(store.getters)
    if (this.id !== undefined && this.id !== '') {
      this.loadPermissions(this.id)
    }
  },
  methods: {
    add() {
      this.form.resetFields()
      this.checkedKeys = []
      this.pidSet = []
      this.RoleType = false
      this.visible = true
      // this.edit({ })
    },
    timeout1(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },
    async edit(record) {
      this.RoleType = true
      this.permissions = []
      if (record.roleId) {
        this.loadPermissions(record.relationId)
        this.timeout1(100).then(() => {
          getRolePermIds(record.roleId).then((res) => {
            const pidSet = new Set(res.map((m) => m.parentId).filter((id) => id > 0))
            this.pidSet = pidSet
            // 因为antd 树插件勾选父节点会导致所有子节点选中,所以过滤所有父节点
            this.checkedKeys = res.map((m) => m.menuId).filter((id) => !pidSet.has(id))
          })
        })
      }
      this.mdl = Object.assign({}, record)
      // 如果没有check过，半选节点是拿不到的，只能通过预先设置的pidSet获取
      this.treeCheck = false
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl, 'roleId', 'roleName', 'status', 'roleSort', 'roleKey', 'relationId'))
        // this.form.setFieldsValue(...record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys)
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck(checkedKeys, info) {
      if (!this.treeCheck) this.treeCheck = true
      console.log('onCheck', info)
      this.checkedKeys = checkedKeys
      this.halfCheckedKeys = info.halfCheckedKeys
    },
    onSelect(selectedKeys, info) {
      console.log('onSelect', info)
      this.selectedKeys = selectedKeys
    },
    loadPermissions(enterpriseId) {
      getEntPermissions({ enterpriseId: enterpriseId }).then((res) => {
        this.buildtree(res.rows, this.permissions, 0)
      })
    },
    buildtree(list, permissions, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.menuId,
            title: item.menuName,
            children: [],
          }
          this.buildtree(list, child.children, item.menuId)
          permissions.push(child)
        }
      })
    },
    changeEnterprise(value) {
      this.permissions = []
      this.loadPermissions(value)
    },
    handleOk(e) {
      const _this = this
      // 如果没有check过，半选节点是拿不到的，只能通过预先设置的pidSet获取
      const checkedAll = this.treeCheck
        ? _this.checkedKeys.concat(_this.halfCheckedKeys)
        : _this.checkedKeys.concat(Array.from(_this.pidSet))
      if (!checkedAll.length > 0) {
        _this.$message.warning('请至少选择一个权限')
        return
      }
      // 触发表单验证
      this.form.validateFields((err, values) => {
        // 验证表单没错误
        if (!err) {
          if (_this.id !== undefined && _this.id !== '') {
            values.relationId = _this.id
          }
          values.menuIds = checkedAll
          // _this.confirmLoading = true
          values['roleType'] = '22'
          console.log(values)
          saveRole(Object.assign(values))
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success('保存成功')
                if (values.roleId != undefined) {
                  _this.$emit('ok', 2)
                } else {
                  _this.$emit('ok', 1)
                }

                _this.visible = false
              } else {
                _this.$message.success(res.msg)
              }
            })
            .catch(() => {
              _this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              _this.confirmLoading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
</style>
